import { render } from "./questionOne.vue?vue&type=template&id=a63e5fce"
import script from "./questionOne.vue?vue&type=script&lang=js"
export * from "./questionOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__